import {TicketWithFormattedSalePeriod} from '@wix/wix-events-commons-statics'
import {AnyAction} from 'redux'

const defaultState: TicketWithFormattedSalePeriod[] = []

export const demoTickets = (state = defaultState, action: AnyAction): TicketWithFormattedSalePeriod[] => {
  switch (action.type) {
    default:
      return state
  }
}
